import template from './loansDetailPurposes.html';
import './loansDetailPurposes.scss';

let loansDetailPurposesComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
};

export default loansDetailPurposesComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailPurposes/loansDetailPurposes.component.js